export default "<p>delivery-address-list works!</p>\r\n";